var map = {
	"./de/btn-download-pc.png": "rZlX",
	"./en/btn-download-pc.png": "2y2l",
	"./es/btn-download-pc.png": "inU4",
	"./fr/btn-download-pc.png": "dI0Q",
	"./ja/btn-download-pc.png": "XzaT",
	"./ko/btn-download-pc.png": "jbAD",
	"./pt/btn-download-pc.png": "m/2n",
	"./ru/btn-download-pc.png": "GV92",
	"./tc/btn-download-pc.png": "RPfu",
	"./th/btn-download-pc.png": "l5d2",
	"./zh-Hant/btn-download-pc.png": "AYol"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XpSt";